<template>
  <component :is="componentType" :mirror-layout="mirrored" v-bind="$attrs" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PageIntroHeaderHorizontal from './PageIntroHeaderHorizontal.vue';
import PageIntroHeaderVertical from './PageIntroHeaderVertical.vue';

export default defineComponent({
  name: 'PageIntroHeader',
  components: {
    PageIntroHeaderVertical,
    PageIntroHeaderHorizontal
  },
  props: {
    horizontalLayout: {
      type: Boolean,
      default: false
    },
    mirrorLayout: {
      type: String,
      default: 'false'
    }
  },
  computed: {
    componentType(): string {
      return this.horizontalLayout
        ? 'page-intro-header-horizontal'
        : 'page-intro-header-vertical';
    },
    mirrored(): boolean {
      return JSON.parse(this.mirrorLayout ?? false);
    }
  }
});
</script>
